export default "__VITE_ASSET__BPTdGDIM__"